import { render, staticRenderFns } from "./mapRightItem.vue?vue&type=template&id=6cbe465d&scoped=true&"
import script from "./mapRightItem.vue?vue&type=script&lang=js&"
export * from "./mapRightItem.vue?vue&type=script&lang=js&"
import style0 from "./mapRightItem.vue?vue&type=style&index=0&id=6cbe465d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe465d",
  null
  
)

export default component.exports